module.exports = __webpack_public_path__ + "img/ObjectImage.96dfb4e8.svg";